import {RouteObject} from 'react-router-dom';
import { LIBRARY, LOGIN, LOGIN_CONSENT, OWNER, ROOT, CLASS, VIDEO, TOS, PRIVACY, ABOUT, ACCOUNT } from './routes';
import Layout from './components/Layout';
import LoginGateway from './pages/LoginGateway';
// Legal pages
import ServiceTerms from './pages/ServiceTerms';
import PrivacyTerms from './pages/PrivacyTerms';
import AboutCompany from './pages/AboutCompany';
import LoginConsent from './pages/LoginConsent';
import TitleWelcome from './pages/TitleWelcome';
import ClassContext from './pages/ClassContext';
import ActorAccount from './pages/ActorAccount';
// Removed Explore page import
import ActorLibrary from './pages/ActorLibrary';
import OwnerContext from './pages/OwnerContext';
import VideoContext from './pages/VideoContext';

/**
 * Route configuration using React Router v6 useRoutes().
 * Nested under Layout for shared shell (AppBar, player, drawer).
 */
const routesConfig: RouteObject[] = [
  { path: LOGIN, element: <LoginGateway /> },
  { path: LOGIN_CONSENT, element: <LoginConsent /> },
  // Legal pages
  { path: TOS, element: <ServiceTerms /> },
  { path: PRIVACY, element: <PrivacyTerms /> },
  { path: ABOUT, element: <AboutCompany /> },
  {
    element: <Layout />,
    children: [
      { path: ROOT,      element: <TitleWelcome /> },
      { path: LIBRARY,   element: <ActorLibrary /> },
      { path: OWNER,     element: <OwnerContext /> },
      { path: CLASS,     element: <ClassContext /> },
      { path: VIDEO,     element: <VideoContext /> },
      { path: ACCOUNT,   element: <ActorAccount /> },
    ],
  },
];

export default routesConfig;